import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import './MainYDC.scss';
import PageTitle from '../../widgets/PageTitle/PageTitle';
// import ydc2024 from '../../assets/images/ydc2024.jpg';
import config from '../../config';

const MainYDC = (props) => {
  const { curLang, homeData } = props;

  const leftImage_url = homeData?.ydc?.leftImage_url || '';
  const rightImage_url = homeData?.ydc?.rightImage_url || '';

  return (
    <section className="main-ydc">
      <PageTitle title="YDC" link={`${config.routePathTo}/${curLang}/ydc/about`} />
      <Row>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="left-col">
          <a
            href={
              leftImage_url.includes('https')
                ? leftImage_url + '?ref_source=fashionally_home_ydc'
                : `${config.routePathTo}/${curLang}${leftImage_url}?ref_source=fashionally_home_ydc`
            }
          >
            <img src={homeData?.ydc?.leftImage_upload} className="left-img" />
          </a>
        </Col>
        <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8} className="right-col">
          <a
            href={
              rightImage_url.includes('https')
                ? rightImage_url + '?ref_source=fashionally_home_ydc'
                : `${config.routePathTo}/${curLang}${rightImage_url}?ref_source=fashionally_home_ydc`
            }
          >
            <img src={homeData?.ydc?.rightImage_upload} className="right-img" />
          </a>
        </Col>
      </Row>
    </section>
  );
};

export default MainYDC;
